<script>
  import fetch from "./helpers/fetch";

  let username = "";
  let password = "";
  let loading = false;
  let result = null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    loading = true;

    result = await fetch("https://ericrabiner.com/api/auth/login", {
      method: "POST",
      body: {
        username,
        password,
      },
    });

    loading = false;
  };
</script>

<main>
  <img src="/images/ericrabiner-logo.png" alt="eric rabiner" />

  <div class="form">
    <div class="field">
      <div class="control">
        <input
          class="input is-info"
          type="text"
          placeholder="Username"
          bind:value={username}
        />
      </div>
    </div>
    <div class="field">
      <div class="control">
        <input
          class="input is-info"
          type="password"
          placeholder="Password"
          bind:value={password}
        />
      </div>
    </div>
    <div class="field">
      <button
        class={`button is-info is-fullwidth ${loading ? "is-loading" : ""}`}
        on:click={handleSubmit}>Login</button
      >
    </div>

    {#if result}
      <div class="notification is-danger is-light">
        {result.message}
      </div>
    {/if}
  </div>
</main>

<style>
  main {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    overflow-y: hidden;
  }
  img {
    width: 250px;
    height: 250px;
    margin-bottom: 0.75rem;
  }
  .form {
    padding: 0 0.75rem;
    width: 100%;
    max-width: 500px;
  }
</style>
